import React from 'react';
import {
  Stack,
  Icon,
  Text,
} from '@piwikpro/ui-components';

export interface IFailMessageProps {
  t: (key: string) => string
}

export function FailMessage({ t }: IFailMessageProps) {
  return (
    <Stack
      vertical
      horizontalAlignment="middle"
      verticalAlignment="center"
      spacing="extraWide"
    >
      <Stack.Item fill />
      <Stack.Item>
        <Stack
          vertical
          horizontalAlignment="middle"
        >
          <Stack.Item>
            <Icon
              color="red"
              name="exclamation-mark-circle"
              size="medium"
            />
          </Stack.Item>
          <Stack.Item>
            <Text color="Red" dataId="TextStyle.Red">
              {t('accountSecurity.twoFactorAuth.load.failed.description')}
            </Text>
          </Stack.Item>
        </Stack>
      </Stack.Item>
      <Stack.Item fill />
    </Stack>
  );
}

export default FailMessage;
